import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { TDWModuleType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';

export function getDeleteTDWType(modelType) {
    let moduleType: string|null = null;
    switch (modelType) {
        case UIModelType.SHAPE:
            moduleType = TDWModuleType.M_SHAPE_EDIT;
            break;
        case UIModelType.IMAGE:
            moduleType = TDWModuleType.M_PIC_EDIT;
            break;
        case UIModelType.TABLE:
            moduleType = TDWModuleType.M_EXCEL_EDIT;
            break;
    }
    return moduleType;
}
